import {
  Box,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ringLogo from "../../assets/images/2 1.svg";
import schemeImg1 from "../../assets/Scehem1-01.png";
import schemeImg2 from "../../assets/Scehem2.png";
import schemeImg3 from "../../assets/Scehem3-01.png";
// import Background1 from "../../assets/images/22.png";
// import Background2 from "../../assets/images/23.png";
// import Background3 from "../../assets/images/24.png";
import ButtonComponent from "../../components/button/button.component";
import Navbar from "../../components/navbar/navbar.component";
import { generalToastStyle } from "../../utils/toast.styles";

const Schemes_form = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const searchParams = useSearchParams();
  const planId = searchParams[0].get("plan");
  // const heroBackgrounds = {
  //   1: Background1,
  //   2: Background2,
  //   3: Background3,
  // };

  // const heroImage = heroBackgrounds[parseInt(planId)] || Background1;

  const [selectedPlan, setSelectedPlan] = useState(planId);
  const [schemes, setSchemes] = useState([]);
  const [benefits, setBenefits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Renders Daily Gold Savings table with savings progression
  const renderDailyGoldSavingsTable = () => {
    const savingsData = [
      { date: "1-1-25", installment: 10000, total: 10000, benefits: "-" },
      { date: "5-1-25", installment: 10000, total: 20000, benefits: "-" },
      { date: "6-1-25", installment: 10000, total: 30000, benefits: "-" },
      { date: "10-1-25", installment: 10000, total: 40000, benefits: "-" },
      { date: "5-2-25", installment: 10000, total: 50000, benefits: "-" },
      { date: "15-2-25", installment: 10000, total: 60000, benefits: "2 months No Benefit" },
      { date: "25-2-25", installment: 10000, total: 70000, benefits: "Buy any product and get 25% Discount on Making charges on Silver Article, Silver Gold, & Diamond Jewellery" },
      { date: "30-2-25", installment: 10000, total: 80000, benefits: "Buy any product and get 25% Discount on Making charges on Silver Article, Silver Gold, & Diamond Jewellery" },
      { date: "1-3-25", installment: 10000, total: 90000, benefits: "Buy any product and get 25% Discount on Making charges on Silver Article, Silver Gold, & Diamond Jewellery" }
    ];

    // Build merged blocks for "Benefits" column
    const getBenefitsMergedBlocks = () => {
      return [
        { start: 0, span: 5, text: "-" },
        { start: 5, span: 1, text: "2 months No Benefit" },
        { start: 6, span: 3, text: "Buy any product and get 25% Discount on Making charges on Silver Article, Silver Gold, & Diamond Jewellery" },
      ];
    };

    const benefitsMergedBlocks = getBenefitsMergedBlocks();

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "12px", whiteSpace: "nowrap" }}>Date</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "12px" }}>Installment (Min ₹100)</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "12px" }}>Total Amount</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "12px" }}>Benefits</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {savingsData.map((row, idx) => {
            // Determine if a merged block starts here
            const benefitsBlock = benefitsMergedBlocks.find((b) => b.start === idx);
            return (
              <Box component="tr" key={`${row.date}-${idx}`}>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "11px", whiteSpace: "nowrap" }}>{row.date}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "11px" }}>₹{row.installment.toLocaleString("en-IN")}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "11px" }}>₹{row.total.toLocaleString("en-IN")}</Box>
                {benefitsBlock ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "11px" }} rowSpan={benefitsBlock.span}>
                    {benefitsBlock.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  benefitsMergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "11px" }}>
                      {row.benefits}
                    </Box>
                  )
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };

  // Renders Plan 1 Gold Jewelry table with calculations
  const renderPlan1GoldTable = () => {
    const plan1GoldData = [
      { 
        month: "Jan", 
        installment: 5000, 
        totalPaid: 5000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        goldWeight: "0.83gm"
      },
      { 
        month: "Feb", 
        installment: 5000, 
        totalPaid: 10000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        goldWeight: "1.67gm"
      },
      { 
        month: "Mar", 
        installment: 5000, 
        totalPaid: 15000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        goldWeight: "2.50gm"
      },
      { 
        month: "Apr", 
        installment: 5000, 
        totalPaid: 20000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        goldWeight: "3.33gm"
      },
      { 
        month: "May", 
        installment: 5000, 
        totalPaid: 25000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        goldWeight: "4.17gm"
      },
      { 
        month: "Jun", 
        installment: 5000, 
        totalPaid: 30000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹5,000 = ₹1,250",
        goldWeight: "5.00gm"
      },
      { 
        month: "Jul", 
        installment: 5000, 
        totalPaid: 35000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹5,000 = ₹1,250",
        goldWeight: "5.83gm"
      },
      { 
        month: "Aug", 
        installment: 5000, 
        totalPaid: 40000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹5,000 = ₹1,250",
        goldWeight: "6.67gm"
      },
      { 
        month: "Sep", 
        installment: 5000, 
        totalPaid: 45000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹5,000 = ₹1,250",
        goldWeight: "7.50gm"
      },
      { 
        month: "Oct", 
        installment: 5000, 
        totalPaid: 50000, 
        ifDiscontinued: "50% of the benefit", 
        benefits: "50% of ₹5,000 = ₹2,500",
        goldWeight: "8.33gm"
      },
      { 
        month: "Nov", 
        installment: 5000, 
        totalPaid: 55000, 
        ifDiscontinued: "50% of the benefit", 
        benefits: "50% of ₹5,000 = ₹2,500",
        goldWeight: "9.17gm"
      }
    ];

    // Build merged blocks for "If Discontinued" column
    const getMergedBlocks = () => {
      return [
        { start: 0, span: 5, text: "No benefit" },
        { start: 5, span: 4, text: "25% of the benefit" },
        { start: 9, span: 2, text: "50% of the benefit" },
      ];
    };

    // Build merged blocks for "Benefits" column
    const getBenefitsMergedBlocks = () => {
      return [
        { start: 0, span: 5, text: "No benefits for 5 months" },
        { start: 5, span: 4, text: "25% of ₹5,000 = ₹1,250" },
        { start: 9, span: 2, text: "50% of ₹5,000 = ₹2,500" },
      ];
    };

    const mergedBlocks = getMergedBlocks();
    const benefitsMergedBlocks = getBenefitsMergedBlocks();

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Month</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Installment Amount</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Total Paid</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>If Discontinued</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Benefits</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Gold Rate Apply</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {plan1GoldData.map((row, idx) => {
            // Determine if a merged block starts here
            const block = mergedBlocks.find((b) => b.start === idx);
            const benefitsBlock = benefitsMergedBlocks.find((b) => b.start === idx);
            return (
              <Box component="tr" key={`${row.month}-${idx}`}>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>{row.month}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.installment.toLocaleString("en-IN")}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.totalPaid.toLocaleString("en-IN")}</Box>
                {block ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={block.span}>
                    {block.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  mergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.ifDiscontinued}
                    </Box>
                  )
                )}
                {benefitsBlock ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={benefitsBlock.span}>
                    {benefitsBlock.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  benefitsMergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.benefits}
                    </Box>
                  )
                )}
                {idx === 0 ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center", writingMode: "vertical-rl", textOrientation: "mixed", minHeight: "80px" }} rowSpan={11}>
                    End of scheme or when you'll redeem scheme
                  </Box>
                ) : null}
              </Box>
            );
          })}
          {/* Summary Row */}
          <Box component="tr" sx={{ backgroundColor: "#f0f8ff" }}>
            <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center", fontWeight: "bold" }} colSpan={6}>
              After maturity of 11 months you'll get discount of 100% on making charge of gold jewellery, diamond jewellery and silver article.
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  // Renders Plan 1 Silver Articles table with calculations
  const renderPlan1SilverTable = () => {
    const plan1SilverData = [
      { 
        month: "Jan", 
        installment: 3000, 
        totalPaid: 3000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        silverWeight: "40.00g"
      },
      { 
        month: "Feb", 
        installment: 3000, 
        totalPaid: 6000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        silverWeight: "80.00g"
      },
      { 
        month: "Mar", 
        installment: 3000, 
        totalPaid: 9000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        silverWeight: "120.00g"
      },
      { 
        month: "Apr", 
        installment: 3000, 
        totalPaid: 12000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        silverWeight: "160.00g"
      },
      { 
        month: "May", 
        installment: 3000, 
        totalPaid: 15000, 
        ifDiscontinued: "No benefit", 
        benefits: "No benefits for 5 months",
        silverWeight: "200.00g"
      },
      { 
        month: "Jun", 
        installment: 3000, 
        totalPaid: 18000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹3,000 = ₹750",
        silverWeight: "240.00g"
      },
      { 
        month: "Jul", 
        installment: 3000, 
        totalPaid: 21000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹3,000 = ₹750",
        silverWeight: "280.00g"
      },
      { 
        month: "Aug", 
        installment: 3000, 
        totalPaid: 24000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹3,000 = ₹750",
        silverWeight: "320.00g"
      },
      { 
        month: "Sep", 
        installment: 3000, 
        totalPaid: 27000, 
        ifDiscontinued: "25% of the benefit", 
        benefits: "25% of ₹3,000 = ₹750",
        silverWeight: "360.00g"
      },
      { 
        month: "Oct", 
        installment: 3000, 
        totalPaid: 30000, 
        ifDiscontinued: "50% of the benefit", 
        benefits: "50% of ₹3,000 = ₹1,500",
        silverWeight: "400.00g"
      },
      { 
        month: "Nov", 
        installment: 3000, 
        totalPaid: 33000, 
        ifDiscontinued: "50% of the benefit", 
        benefits: "50% of ₹3,000 = ₹1,500",
        silverWeight: "440.00g"
      }
    ];

    // Build merged blocks for "If Discontinued" column
    const getMergedBlocks = () => {
      return [
        { start: 0, span: 5, text: "No benefit" },
        { start: 5, span: 4, text: "25% of the benefit" },
        { start: 9, span: 2, text: "50% of the benefit" },
      ];
    };

    // Build merged blocks for "Benefits" column
    const getBenefitsMergedBlocks = () => {
      return [
        { start: 0, span: 5, text: "No benefits for 5 months" },
        { start: 5, span: 4, text: "25% of ₹3,000 = ₹750" },
        { start: 9, span: 2, text: "50% of ₹3,000 = ₹1,500" },
      ];
    };

    const mergedBlocks = getMergedBlocks();
    const benefitsMergedBlocks = getBenefitsMergedBlocks();

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Month</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Installment Amount</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Total Paid</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>If Discontinued</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Benefits</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Silver Rate Apply</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {plan1SilverData.map((row, idx) => {
            // Determine if a merged block starts here
            const block = mergedBlocks.find((b) => b.start === idx);
            const benefitsBlock = benefitsMergedBlocks.find((b) => b.start === idx);
            return (
              <Box component="tr" key={`${row.month}-${idx}`}>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>{row.month}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.installment.toLocaleString("en-IN")}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.totalPaid.toLocaleString("en-IN")}</Box>
                {block ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={block.span}>
                    {block.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  mergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.ifDiscontinued}
                    </Box>
                  )
                )}
                {benefitsBlock ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={benefitsBlock.span}>
                    {benefitsBlock.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  benefitsMergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.benefits}
                    </Box>
                  )
                )}
                {idx === 0 ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center", writingMode: "vertical-rl", textOrientation: "mixed", minHeight: "80px" }} rowSpan={11}>
                    End of scheme or when you'll redeem scheme
                  </Box>
                ) : null}
              </Box>
            );
          })}
          {/* Summary Row */}
          <Box component="tr" sx={{ backgroundColor: "#f0f8ff" }}>
            <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center", fontWeight: "bold" }} colSpan={6}>
              After maturity of 11 months you'll get discount of 100% on making charge of gold jewellery, diamond jewellery and silver article.
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  // Renders detailed Plan 2 Silver table for examples
  const renderPlan2SilverTable = () => {
    const plan2SilverData = [
      { 
        month: "Jan", 
        installment: 10000, 
        totalPaid: 10000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        silverAccumulation: "142.86g"
      },
      { 
        month: "Feb", 
        installment: 10000, 
        totalPaid: 20000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        silverAccumulation: "285.72g"
      },
      { 
        month: "Mar", 
        installment: 10000, 
        totalPaid: 30000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        silverAccumulation: "428.58g"
      },
      { 
        month: "Apr", 
        installment: 10000, 
        totalPaid: 40000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        silverAccumulation: "571.44g"
      },
      { 
        month: "May", 
        installment: 10000, 
        totalPaid: 50000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        silverAccumulation: "714.30g"
      },
      { 
        month: "Jun", 
        installment: 10000, 
        totalPaid: 60000, 
        ifDiscontinued: "15% discount on making charge", 
        benefits: "15% of ₹10,000 = ₹1,500",
        silverAccumulation: "857.16g"
      },
      { 
        month: "Jul", 
        installment: 10000, 
        totalPaid: 70000, 
        ifDiscontinued: "15% discount on making charge", 
        benefits: "15% of ₹10,000 = ₹1,500",
        silverAccumulation: "1000.02g"
      },
      { 
        month: "Aug", 
        installment: 10000, 
        totalPaid: 80000, 
        ifDiscontinued: "15% discount on making charge", 
        benefits: "15% of ₹10,000 = ₹1,500",
        silverAccumulation: "1142.88g"
      },
      { 
        month: "Sep", 
        installment: 10000, 
        totalPaid: 90000, 
        ifDiscontinued: "25% discount on making charge", 
        benefits: "25% of ₹10,000 = ₹2,500",
        silverAccumulation: "1285.74g"
      },
      { 
        month: "Oct", 
        installment: 10000, 
        totalPaid: 100000, 
        ifDiscontinued: "25% discount on making charge", 
        benefits: "25% of ₹10,000 = ₹2,500",
        silverAccumulation: "1428.60g"
      }
    ];

    // Build merged blocks for "If Discontinued" column
    const getMergedBlocks = () => {
      return [
        { start: 0, span: 5, text: "No discount on making charge" },
        { start: 5, span: 3, text: "15% discount on making charge" },
        { start: 8, span: 2, text: "25% discount on making charge" },
      ];
    };

    // Build merged blocks for "Benefits" column
    const getBenefitsMergedBlocks = () => {
      return [
        { start: 0, span: 5, text: "No benefits for 5 months" },
        { start: 5, span: 3, text: "15% of ₹10,000 = ₹1,500" },
        { start: 8, span: 2, text: "25% of ₹10,000 = ₹2,500" },
      ];
    };

    const mergedBlocks = getMergedBlocks();
    const benefitsMergedBlocks = getBenefitsMergedBlocks();

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Month</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Installment Amount</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Total Paid</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>If Discontinued</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Benefits</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Sample Silver Accumulation</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {plan2SilverData.map((row, idx) => {
            // Determine if a merged block starts here
            const block = mergedBlocks.find((b) => b.start === idx);
            const benefitsBlock = benefitsMergedBlocks.find((b) => b.start === idx);
            return (
              <Box component="tr" key={`${row.month}-${idx}`}>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>{row.month}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.installment.toLocaleString("en-IN")}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.totalPaid.toLocaleString("en-IN")}</Box>
                {block ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={block.span}>
                    {block.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  mergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.ifDiscontinued}
                    </Box>
                  )
                )}
                {benefitsBlock ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={benefitsBlock.span}>
                    {benefitsBlock.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  benefitsMergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.benefits}
                    </Box>
                  )
                )}
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>{row.silverAccumulation} (₹70/gram)</Box>
              </Box>
            );
          })}
          {/* Summary Row */}
          <Box component="tr" sx={{ backgroundColor: "#f0f8ff" }}>
            <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center", fontWeight: "bold" }} colSpan={6}>
              Full benefits of scheme 40% of making charge. If making charge is ₹10,000 redemption is ₹4,000 rs and real time accumulation of both gold and silver jewellery.
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  // Renders detailed Plan 2 table for examples
  const renderPlan2ExampleTable = () => {
    const plan2Data = [
      { 
        month: "Jan", 
        installment: 10000, 
        totalPaid: 10000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        goldAccumulation: "2gm (₹5,000/gm)"
      },
      { 
        month: "Feb", 
        installment: 10000, 
        totalPaid: 20000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        goldAccumulation: "3.92gm (₹5,100/gm)"
      },
      { 
        month: "Mar", 
        installment: 10000, 
        totalPaid: 30000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        goldAccumulation: "5.92gm (₹5,067/gm)"
      },
      { 
        month: "Apr", 
        installment: 10000, 
        totalPaid: 40000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        goldAccumulation: "7.74gm (₹5,165/gm)"
      },
      { 
        month: "May", 
        installment: 10000, 
        totalPaid: 50000, 
        ifDiscontinued: "No discount on making charge", 
        benefits: "No benefits for 5 months",
        goldAccumulation: "9.74gm (₹5,133/gm)"
      },
      { 
        month: "Jun", 
        installment: 10000, 
        totalPaid: 60000, 
        ifDiscontinued: "15% discount on making charge", 
        benefits: "15% of ₹10,000 = ₹1,500",
        goldAccumulation: "11.66gm (₹5,145/gm)"
      },
      { 
        month: "Jul", 
        installment: 10000, 
        totalPaid: 70000, 
        ifDiscontinued: "15% discount on making charge", 
        benefits: "15% of ₹10,000 = ₹1,500",
        goldAccumulation: "13.66gm (₹5,125/gm)"
      },
      { 
        month: "Aug", 
        installment: 10000, 
        totalPaid: 80000, 
        ifDiscontinued: "15% discount on making charge", 
        benefits: "15% of ₹10,000 = ₹1,500",
        goldAccumulation: "15.48gm (₹5,165/gm)"
      },
      { 
        month: "Sep", 
        installment: 10000, 
        totalPaid: 90000, 
        ifDiscontinued: "25% discount on making charge", 
        benefits: "25% of ₹10,000 = ₹2,500",
        goldAccumulation: "17.48gm (₹5,149/gm)"
      },
      { 
        month: "Oct", 
        installment: 10000, 
        totalPaid: 100000, 
        ifDiscontinued: "25% discount on making charge", 
        benefits: "25% of ₹10,000 = ₹2,500",
        goldAccumulation: "19.4gm (₹5,155/gm)"
      }
    ];

    // Build merged blocks for "If Discontinued" column
    const getMergedBlocks = () => {
        return [
        { start: 0, span: 5, text: "No discount on making charge" },
        { start: 5, span: 3, text: "15% discount on making charge" },
        { start: 8, span: 2, text: "25% discount on making charge" },
      ];
    };

    // Build merged blocks for "Benefits" column
    const getBenefitsMergedBlocks = () => {
        return [
        { start: 0, span: 5, text: "No benefits for 5 months" },
        { start: 5, span: 3, text: "15% of ₹10,000 = ₹1,500" },
        { start: 8, span: 2, text: "25% of ₹10,000 = ₹2,500" },
      ];
    };

    // Build merged blocks for "Gold Accumulation" column
    const getGoldAccumulationMergedBlocks = () => {
      return [
        { start: 0, span: 10, text: "22kt - 2gm (₹5,000/gm) | 22kt - 1.92gm (₹5,200/gm) | 22kt - 1.82gm (₹5,500/gm)" },
      ];
    };

    const mergedBlocks = getMergedBlocks();
    const benefitsMergedBlocks = getBenefitsMergedBlocks();
    const goldAccumulationMergedBlocks = getGoldAccumulationMergedBlocks();

    return (
        <Box
          component="table"
          sx={{
            width: "100%",
            borderCollapse: "collapse",
            background: "#fafafa",
            borderRadius: 1,
            overflow: "hidden",
          mb: 3,
          }}
        >
          <Box component="thead" sx={{ background: "#f3e5cf" }}>
            <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Month</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Installment Amount</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Total Paid</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>If Discontinued</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Benefits</Box>
            <Box component="th" sx={{ p: 1, textAlign: "center", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Sample Gold Accumulation</Box>
            </Box>
          </Box>
          <Box component="tbody">
          {plan2Data.map((row, idx) => {
              // Determine if a merged block starts here
              const block = mergedBlocks.find((b) => b.start === idx);
            const benefitsBlock = benefitsMergedBlocks.find((b) => b.start === idx);
              return (
              <Box component="tr" key={`${row.month}-${idx}`}>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>{row.month}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.installment.toLocaleString("en-IN")}</Box>
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>₹{row.totalPaid.toLocaleString("en-IN")}</Box>
                  {block ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={block.span}>
                      {block.text}
                    </Box>
                  ) : (
                    // If not start of a merged block and within a merged region, skip rendering this cell entirely
                    mergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.ifDiscontinued}
                      </Box>
                    )
                  )}
                {benefitsBlock ? (
                  <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }} rowSpan={benefitsBlock.span}>
                    {benefitsBlock.text}
                  </Box>
                ) : (
                  // If not start of a merged block and within a merged region, skip rendering this cell entirely
                  benefitsMergedBlocks.some((b) => idx > b.start && idx < b.start + b.span) ? null : (
                    <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>
                      {row.benefits}
                    </Box>
                  )
                )}
                <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center" }}>{row.goldAccumulation}</Box>
                </Box>
              );
            })}
          {/* Summary Row */}
          <Box component="tr" sx={{ backgroundColor: "#f0f8ff" }}>
            <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", textAlign: "center", fontWeight: "bold" }} colSpan={6}>
              Full benefits of scheme 40% of making charge. If making charge is ₹10,000 redemption is ₹4,000 rs and real time accumulation of both gold and silver jewellery.
          </Box>
        </Box>
        </Box>
      </Box>
    );
  };

  // Renders Gold Accumulation table for scheme 2
  const renderGoldAccumulationTable = () => {
    const goldData = [
      { month: "Jan", installment: 10000, goldRate: 5000, goldBought: 2.00, totalGold: 2.00 },
      { month: "Feb", installment: 10000, goldRate: 5200, goldBought: 1.92, totalGold: 3.92 },
      { month: "Mar", installment: 10000, goldRate: 5000, goldBought: 2.00, totalGold: 5.92 },
      { month: "Apr", installment: 10000, goldRate: 5500, goldBought: 1.82, totalGold: 7.74 },
      { month: "May", installment: 10000, goldRate: 5000, goldBought: 2.00, totalGold: 9.74 },
      { month: "Jun", installment: 10000, goldRate: 5200, goldBought: 1.92, totalGold: 11.66 },
      { month: "Jul", installment: 10000, goldRate: 5000, goldBought: 2.00, totalGold: 13.66 },
      { month: "Aug", installment: 10000, goldRate: 5500, goldBought: 1.82, totalGold: 15.48 },
      { month: "Sep", installment: 10000, goldRate: 5000, goldBought: 2.00, totalGold: 17.48 },
      { month: "Oct", installment: 10000, goldRate: 5200, goldBought: 1.92, totalGold: 19.40 }
    ];

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Month</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Installment</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Gold Rate</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Gold Bought</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Total Gold</Box>
        </Box>
        </Box>
        <Box component="tbody">
          {goldData.map((row, idx) => (
            <Box component="tr" key={`${row.month}-${idx}`}>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>{row.month}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>₹{row.installment.toLocaleString("en-IN")}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>₹{row.goldRate.toLocaleString("en-IN")}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>{row.goldBought}g</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>{row.totalGold}g</Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  // Renders Silver Accumulation table for scheme 2
  const renderSilverAccumulationTable = () => {
    const silverData = [
      { month: "Jan", installment: 10000, silverRate: 70, silverBought: 142.86, totalSilver: 142.86 },
      { month: "Feb", installment: 10000, silverRate: 75, silverBought: 133.33, totalSilver: 276.19 },
      { month: "Mar", installment: 10000, silverRate: 70, silverBought: 142.86, totalSilver: 419.05 },
      { month: "Apr", installment: 10000, silverRate: 80, silverBought: 125.00, totalSilver: 544.05 },
      { month: "May", installment: 10000, silverRate: 70, silverBought: 142.86, totalSilver: 686.91 },
      { month: "Jun", installment: 10000, silverRate: 75, silverBought: 133.33, totalSilver: 820.24 },
      { month: "Jul", installment: 10000, silverRate: 70, silverBought: 142.86, totalSilver: 963.10 },
      { month: "Aug", installment: 10000, silverRate: 80, silverBought: 125.00, totalSilver: 1088.10 },
      { month: "Sep", installment: 10000, silverRate: 70, silverBought: 142.86, totalSilver: 1230.96 },
      { month: "Oct", installment: 10000, silverRate: 75, silverBought: 133.33, totalSilver: 1364.29 }
    ];

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Month</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Installment</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Silver Rate</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Silver Bought</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Total Silver</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {silverData.map((row, idx) => (
            <Box component="tr" key={`${row.month}-${idx}`}>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>{row.month}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>₹{row.installment.toLocaleString("en-IN")}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>₹{row.silverRate}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>{row.silverBought}g</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>{row.totalSilver}g</Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  // Renders Campaign & Benefits table for scheme 2
  const renderCampaignBenefitsTable = () => {
    const campaignData = [
      { month: "Feb", installedMin: 10000, traffic: 20000, dmpCountries: "No display campaign", benefitSchool: "No benefit", goldBuyerYouth: "21–22 = 29M", notes: "" },
      { month: "March", installedMin: 10000, traffic: 20000, dmpCountries: "Campaign Strength", benefitSchool: "2.5M youths", goldBuyerYouth: "21–22 = 29M", notes: "" },
      { month: "April", installedMin: 10000, traffic: 40000, dmpCountries: "Campaign Strength", benefitSchool: "2.5M youths", goldBuyerYouth: "Peak Son (Aug)", notes: "" },
      { month: "May", installedMin: 10000, traffic: 50000, dmpCountries: "Campaign Strength", benefitSchool: "TV reach + digital", goldBuyerYouth: "Peak Son (Aug)", notes: "" },
      { month: "June", installedMin: 10000, traffic: 60000, dmpCountries: "Campaign Strength", benefitSchool: "TV reach + digital", goldBuyerYouth: "Peak Son (Aug)", notes: "" },
      { month: "July", installedMin: 10000, traffic: 90000, dmpCountries: "Campaign Strength", benefitSchool: "2.5M youths", goldBuyerYouth: "Peak Son (Aug)", notes: "" },
      { month: "August", installedMin: 10000, traffic: 90000, dmpCountries: "Campaign Strength", benefitSchool: "2.5M youths", goldBuyerYouth: "Peak Son (Aug)", notes: "" },
      { month: "Sept", installedMin: 10000, traffic: 100000, dmpCountries: "Campaign Strength", benefitSchool: "2.5M youths", goldBuyerYouth: "Peak Son (Aug)", notes: "" }
    ];

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Month</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Installed Min Base</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px", whiteSpace: "nowrap" }}>Traffic/day</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>DMP Countries</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Benefit of School</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Gold Buyer Youth</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700, fontSize: "11px" }}>Notes</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {campaignData.map((row, idx) => (
            <Box component="tr" key={`${row.month}-${idx}`}>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>{row.month}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>₹{row.installedMin.toLocaleString("en-IN")}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px", whiteSpace: "nowrap" }}>₹{row.traffic.toLocaleString("en-IN")}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px" }}>{row.dmpCountries}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px" }}>{row.benefitSchool}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px" }}>{row.goldBuyerYouth}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0", fontSize: "10px" }}>{row.notes}</Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  // Renders a table view for plan benefits based on redemptionDetails strings
  const renderBenefitTable = (details) => {
    if (!Array.isArray(details) || details.length === 0) return null;
    const rows = details.map((line) => {
      const [left, ...rest] = String(line).split(/\n?\s*-\s*/);
      return { left: left || "—", right: rest.join(" - ") || "—" };
    });

    return (
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fafafa",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box component="thead" sx={{ background: "#f3e5cf" }}>
          <Box component="tr">
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700 }}>Months paid</Box>
            <Box component="th" sx={{ p: 1, textAlign: "left", border: "1px solid #e0cfa0", fontWeight: 700 }}>Benefit if discontinued</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {rows.map((r, idx) => (
            <Box component="tr" key={`${r.left}-${idx}`}>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0" }}>{r.left}</Box>
              <Box component="td" sx={{ p: 1, border: "1px solid #e0cfa0" }}>{r.right}</Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  // Scheme details data
  const schemeDetails = {
    "1": {
      name: "SadāShrī Jewelkart 11-Month Direct Purchase Plan",
      overview: "The 11-Month Direct Purchase Plan allows customers to systematically save and purchase gold jewelry, diamond jewelry, or silver articles with added benefits.",
      keyFeatures: [
        "Fixed monthly installments for 11 months (minimum ₹1,000 per month).",
        "Gold & silver prices will be determined at the scheme's closing time.",
        "Gold & Diamond Jewelry: Zero making charges and zero wastage.",
        "Silver Articles: Zero making charges, but wastage will be added as applicable.",
        "GST will be applicable on purchases.",
        "Flexible Installments: If an installment is missed, it will be postponed to the next month until all 11 installments are completed."
      ],
      examples: [
        {
          title: "Case 1: Gold Jewelry Purchase",
          details: [
            "🔹 Customer Deposits: ₹5,000 per month for 11 months.",
            "🔹 Total Amount Saved: ₹55,000 (₹5,000 × 11 months).",
            "🔹 Gold Price at Scheme Closure: ₹6,000 per gram.",
            "",
            "Gold Jewelry Calculation:",
            "Gold Weight = Total Amount ÷ Gold Price",
            "= ₹55,000 ÷ ₹6,000 per gram",
            "= 9.16 grams",
            "",
            "✅ Zero Making Charges & Zero Wastage apply.",
            "",
            "GST Calculation (3% on Gold Jewelry Purchase)",
            "GST = 3% of ₹55,000 = ₹1,650",
            "",
            "🎉 Final Gold Jewelry Weight Received: 9.16 grams.",
            "💰 Total Amount Payable (Including GST): ₹56,650",
            "",
            "📊 Monthly Breakdown Table:",
            "",
            "TABLE_PLACEHOLDER_PLAN1_GOLD"
          ]
        },
        {
          title: "Case 2: Silver Article Purchase (With Wastage Added)",
          details: [
            "🔹 Customer Deposits: ₹3,000 per month for 11 months.",
            "🔹 Total Amount Saved: ₹33,000 (₹3,000 × 11 months).",
            "🔹 Silver Price at Scheme Closure: ₹75 per gram.",
            "🔹 Wastage Charged: 3% (as applicable).",
            "",
            "Silver Article Calculation:",
            "Silver Weight Before Wastage = Total Amount ÷ Silver Price",
            "= ₹33,000 ÷ ₹75 per gram",
            "= 440 grams",
            "",
            "Final Silver Weight After Adding 3% Wastage:",
            "= 440 grams + 3% of 440 grams",
            "= 440 + 13.2",
            "= 453.2 grams",
            "",
            "✅ Zero Making Charges Apply, but wastage is added.",
            "",
            "GST Calculation (3% on Silver Article Purchase)",
            "GST = 3% of ₹33,000 = ₹990",
            "",
            "🎉 Final Silver Article Weight Received: 453.2 grams.",
            "💰 Total Amount Payable (Including GST): ₹33,990",
            "",
            "📊 Monthly Breakdown Table:",
            "",
            "TABLE_PLACEHOLDER_PLAN1_SILVER"
          ]
        },
        {
          title: "Case 2: Silver Article Purchase (With Wastage Added)",
          details: [
            "🔹 Customer Deposits: ₹3,000 per month for 11 months.",
            "🔹 Total Amount Saved: ₹33,000 (₹3,000 × 11 months).",
            "🔹 Silver Price at Scheme Closure: ₹75 per gram.",
            "🔹 Wastage Charged: 3% (as applicable).",
            "",
            "Silver Article Calculation:",
            "Silver Weight Before Wastage = Total Amount ÷ Silver Price",
            "= ₹33,000 ÷ ₹75 per gram",
            "= 440 grams",
            "",
            "Final Silver Weight After Adding 3% Wastage:",
            "= 440 grams + 3% of 440 grams",
            "= 440 + 13.2",
            "= 453.2 grams",
            "",
            "✅ Zero Making Charges Apply, but wastage is added.",
            "",
            "GST Calculation (3% on Silver Article Purchase)",
            "GST = 3% of ₹33,000 = ₹990",
            "",
            "🎉 Final Silver Article Weight Received: 453.2 grams.",
            "💰 Total Amount Payable (Including GST): ₹33,990"
          ]
        }
      ],
      whyChoose: [
        "✔ Hassle-Free Savings: No need to track daily market fluctuations.",
        "✔ Higher Savings Value: Get more gold and silver without extra making charges.",
        "✔ Affordable & Flexible: Start with just ₹1,000 per month.",
        "✔ Trusted & Transparent: Your savings are secure with SadāShrī Jewelkart."
      ],
      redemptionDetails: [
        "0-5 months - No benefit",
        "6-9 month - 25% of the benefit",
        "10,11 month - 50% of the benefit",
        "After 11 month - 100% of the benefit"
      ]
    },
    "2": {
      name: "SadāShrī Jewelkart 10-Month Accumulation Plan",
      overview: "The SadāShrī Jewelkart 10-Month Accumulation Plan allows customers to systematically save and accumulate gold weight, diamond jewelry (based on gold accumulation), and silver articles over 10 months by paying fixed monthly installments. Upon maturity, customers can redeem their accumulated value for gold jewelry, diamond jewelry, or silver articles. Customers will also enjoy a 6% discount on making charges for gold jewelry, diamond jewelry, and silver articles.",
      keyFeatures: [
        "Fixed Monthly Instalments: Minimum monthly instalment: ₹1,000. Installments remain fixed for the entire 10-month duration.",
        "Gold Weight, Diamond Jewelry & Silver Article Accumulation: Installments are converted into gold weight for gold jewelry and diamond jewelry based on prevailing market gold rates. For silver articles, installments are converted based on the silver rate. Accumulated gold weight or silver article quantity is tracked monthly.",
        "Making Charge Discount: Gold Jewelry: 6% discount on making charges. Diamond Jewelry: 40% discount on making charges. Silver Articles: 6% discount on making charges.",
        "Redemption: Customers can redeem their accumulated gold weight for gold jewelry or diamond jewelry. Silver articles are redeemable based on accumulated quantity. Wastage charges apply only to silver articles. Loose diamonds are not applicable under this scheme.",
        "No Missed Installments: If a customer misses an installment, the gold weight or silver articles for that month will be forfeited, with no maturity extensions allowed."
      ],
      examples: [
        {
          title: "Gold Jewelry Example:",
          details: [
            "Monthly Installment: ₹10,000",
            "Gold Rate (Avg.): ₹5,000/gram",
            "Gold Accumulation: Each month, ₹10,000 converts to 2 grams of gold.",
            "Total accumulated: 20 grams after 10 months.",
            "",
            "📊 Monthly Breakdown Table:",
            "",
            "TABLE_PLACEHOLDER_PLAN2_EXAMPLE"
          ]
        },
        {
          title: "Silver Articles Example:",
          details: [
            "Monthly Installment: ₹10,000",
            "",
            "Silver Rate (Avg.): ₹70/gram",
            "",
            "Silver Articles Accumulation: Each month, ₹10,000 converts to 142.86 grams of silver.",
            "",
            "Total accumulated: 1,428.6 grams after 10 months.",
            "",
            "For all categories, customers will receive a 6% discount on making charges at the time of redemption. Wastage charges apply only to silver articles.",
            "",
            "📊 Monthly Breakdown Table:",
            "",
            "TABLE_PLACEHOLDER_PLAN2_SILVER"
          ]
        },
      ],
      benefits: [
        "Flexible Options: Accumulate gold weight, diamond jewelry, or silver articles.",
        "Savings Plan: A structured and systematic way to save for gold jewelry, diamond jewelry, or silver articles.",
        "Making Charge Discount: A 6% discount on making charges for all applicable categories.",
        "Rupee-Cost Averaging: Customers benefit from rupee-cost averaging, mitigating price fluctuations during the plan's duration.",
        "Trusted Brand: Offered by SadāShrī Jewelkart, a trusted name for quality and transparency in jewelry."
      ],
      termsConditions: [
        "Redemption: The plan is redeemable for gold jewelry, diamond jewelry, and silver articles (excluding gold coins and bars). Wastage charges apply only to silver articles.",
        "Missed Installments: If an installment is missed, the gold weight or silver articles for that month will be forfeited, with no maturity extensions allowed.",
        "Discount Eligibility: The 6% discount on making charges applies only to gold jewelry, diamond jewelry, and silver articles at the time of redemption."
      ],
      redemptionDetails: [
        "0-5 months - No benefit",
        "6-9 month - 25% of the benefit",
        "10 month - 50% of the benefit",
        "After 10 month - 100% of the benefit"
      ]
    },
    "3": {
      name: "SadāShrī Jewelkart Daily Gold Savings",
      overview: "A flexible savings plan that allows customers to save daily and redeem anytime for gold jewelry, diamond jewelry, or silver articles with exclusive benefits.",
      keyFeatures: [
        "Start Small, Save Big: Customers can start saving from as little as ₹100 per day with no upper limit.",
        "No Time Restrictions: There is no fixed tenure. Customers can save at their own pace and redeem anytime.",
        "Easy Redemption: Savings can be used to purchase products whenever the customer desires—no waiting period!",
        "10% Discount on Making Charges: Customers get an exclusive 10% discount on making charges when redeeming their savings for: Gold jewellery, Diamond jewelry, Silver articles",
        "Price at the Time of Purchase: The price of the product (gold, diamond, or silver) will be calculated based on the prevailing market price at the time of purchase."
      ],
      examples: [
        {
          title: "Daily Gold Savings Table",
          details: [
            "",
            "📊 Monthly Savings Breakdown:",
            "",
            "The table below shows the savings progression with benefits:",
            "",
            "TABLE_PLACEHOLDER",
            ""
          ]
        }
      ],
      howItWorks: [
        "Flexible Deposits: Customers can deposit money daily, weekly, or monthly as per their convenience. Payments can be made through UPI or online transfers only",
        "Accumulate Savings: The saved amount will be securely maintained under the customer's name in the scheme.",
        "Shop Anytime: Use the accumulated savings to purchase eligible products whenever you want.",
        "Exclusive Benefits: Enjoy a 10% discount on making charges for gold jewelry, diamond jewelry, and silver articles."
      ],
      termsConditions: [
        "The scheme is applicable only for gold jewelry, diamond jewelry, and silver articles purchased at SadāShrī Jewelkart.",
        "The price of the product will be calculated based on the market rate on the date of purchase.",
        "The discount on making charges does not apply to loose gemstones or diamonds.",
        "Customers must ensure sufficient balance in their savings account to purchase desired products.",
        "No penalty for partial or delayed deposits; customers can save as per their convenience.",
        "In case of partial withdrawals, the remaining balance will continue in the scheme."
      ],
      benefits: [
        "Encourages disciplined savings towards high-value purchases.",
        "Offers flexibility to save and buy according to personal milestones."
      ],
      redemptionDetails: [
        "Benefit only after 6 months",
        "Fixed amount"
      ]
    }
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    axios
      .get(`${process.env.REACT_APP_API_URL}v1.0.0/user/schemes/all.php`)
      .then((response) => {
        setSchemes(response.data.response);
        if (planId) {
          const selectedScheme = response.data.response.find(
            (scheme) => scheme.id === planId
          );

          if (selectedScheme) {
            const parsedBenefits = JSON.parse(selectedScheme.benefits);
            setBenefits(parsedBenefits);
          }
        }
      })
      .catch((err) => console.error("Failed to fetch schemes:", err));
  }, [planId]);

  // Get current scheme details
  const currentSchemeDetails = schemeDetails[selectedPlan] || {};

  // Update benefits when plan changes
  useEffect(() => {
    if (selectedPlan && schemes.length > 0) {
      const selectedScheme = schemes.find(
        (scheme) => scheme.id === selectedPlan
      );

      if (selectedScheme) {
        try {
          const parsedBenefits = JSON.parse(selectedScheme.benefits);
          setBenefits(parsedBenefits);
        } catch (error) {
          console.error("Error parsing benefits:", error);
          setBenefits([]);
        }
      } else {
        setBenefits([]);
      }
    }
  }, [selectedPlan, schemes]);

  const handleSavings = async () => {
    // Check if user is logged in
    const token = localStorage.getItem("token");
    if (!token) {
      // Store current page URL to redirect back after login
      const currentUrl = window.location.href;
      console.log("Storing redirect URL:", currentUrl); // Debug log
      localStorage.setItem("redirectAfterLogin", currentUrl);
      navigate("/signin");
      return;
    }

    let selectedScheme = schemes.find((scheme) => scheme.id === selectedPlan);

    if (!selectedScheme) {
      toast("Selected scheme not found", generalToastStyle);
      return;
    }

    if (parseFloat(amount) >= parseFloat(selectedScheme.min_amount)) {
      try {
        // Load Razorpay script first
        const loadRazorpayScript = () => {
          return new Promise((resolve) => {
            if (window.Razorpay) {
              resolve(true);
              return;
            }
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
          });
        };

        const loaded = await loadRazorpayScript();
        if (!loaded) {
          toast.error("Razorpay SDK failed to load", generalToastStyle);
          return;
        }

        // Initialize Razorpay after script is loaded
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY,
          amount: amount * 100,
          currency: "INR",
          name: "SadāShrī Jewelkart",
          description: "SadāShrī Jewelkart Daily Gold Savings",
          handler: async function (response) {
            try {
              const formData = new FormData();
              formData.append("amount", amount);
              formData.append("payment_id", response.razorpay_payment_id);

              await axios.post(
                `${process.env.REACT_APP_API_URL}v1.0.0/user/schemes/savings.php`,
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              );

              toast.success("Payment successful!", generalToastStyle);
              navigate("/my-account/my-schemes");
            } catch (error) {
              toast.error("Failed to process payment", generalToastStyle);
            }
          },
          prefill: {
            email: localStorage.getItem("email") || "",
            contact: localStorage.getItem("phone") || "",
          },
          theme: {
            color: "#A36E29",
          },
        };

        // ✅ Razorpay script load fix
        const loadRazorpayScript1 = () => {
          return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
          });
        };

        const loaded1 = await loadRazorpayScript1();
        if (!loaded1) {
          toast.error("Razorpay SDK failed to load", generalToastStyle);
          return;
        }

        const razorpay = new window.Razorpay(options);
        razorpay.open();
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Payment failed",
          generalToastStyle
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      toast("Amount is less than minimum amount", generalToastStyle);
    }
  };

  const handlePayment = async () => {
    try {
      // Check if user is logged in
      const token = localStorage.getItem("token");
      if (!token) {
        // Store current page URL to redirect back after login
        const currentUrl = window.location.href;
        console.log("Storing redirect URL:", currentUrl); // Debug log
        localStorage.setItem("redirectAfterLogin", currentUrl);
        navigate("/signin");
        return;
      }
      // Checking if amount entered is more than minimum amount
      let selectedScheme = schemes.find((scheme) => scheme.id === selectedPlan);
      if (parseFloat(amount) >= parseFloat(selectedScheme.min_amount)) {
        setIsLoading(true);
        // Creating Plan
        const formData = new FormData();
        formData.append("amount", amount);
        formData.append("scheme", selectedPlan);

        let plan = await axios.post(
          `${process.env.REACT_APP_API_URL}v1.0.0/user/schemes/plan.php`,
          formData
        );

        let rzp_plan_id = plan.data.data.rzp_plan_id || plan.data.data.id;

        // Creating Subscription
        const subFormData = new FormData();
        subFormData.append("scheme", selectedPlan);
        subFormData.append("plan", rzp_plan_id);

        let sub = await axios.post(
          `${process.env.REACT_APP_API_URL}v1.0.0/user/schemes/subscribe.php`,
          subFormData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        let subId = sub.data.data.subscription_id;
        // Load Razorpay script dynamically
        const loadRazorpayScript = () => {
          return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
          });
        };

        // Initialize Razorpay after script loads
        const initRazorpay = async () => {
          const res = await loadRazorpayScript();
          if (!res) {
            alert("Razorpay SDK failed to load");
            return;
          }

          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            subscription_id: subId,
            name: "SadāShrī Jewelkart",
            description: "Monthly Plan Subscription",
            image: "https://sadashrijewelkart.com/logo.png",
            handler: async function (response) {
              console.log(response);
              const formData = new FormData();
              formData.append("scheme", selectedPlan);
              formData.append("plan", rzp_plan_id);
              formData.append(
                "subscription_id",
                response.razorpay_subscription_id
              );
              formData.append("signature", response.razorpay_signature);
              formData.append(
                "authorizing_payment_id",
                response.razorpay_payment_id
              );

              await axios.post(
                `${process.env.REACT_APP_API_URL}v1.0.0/user/schemes/activate.php`,
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              );
              setIsLoading(false);
              toast("Subscription successful", generalToastStyle);
              navigate("/my-account/my-schemes");
            },
            theme: {
              color: "#A36E29",
            },
          };

          const rzp = new window.Razorpay(options);
          rzp.open();
        };

        await initRazorpay();
      } else {
        toast("Amount is less than minimum amount", generalToastStyle);
      }
    } catch (error) {
      alert("Something went wrong");
      console.error(error);
    }
  };

  return (
    <>
      <Box>
        <Navbar />
      </Box>
      <ToastContainer />

      {isMobile ? (
        <div>
          <div style={{ width: "100%", overflow: "hidden", marginTop: "20vh" }}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/${
                planId === "1"
                  ? "24.webp"
                  : planId === "2"
                  ? "23.webp"
                  : "22.webp"
              }`}
              alt="Scheme Background"
              style={{
                width: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
          <Card
            sx={{
              width: "90%",
              maxWidth: "400px",
              margin: "0 auto",
              borderRadius: "12px",
              boxShadow: 3,
              position: "relative",
              marginTop: "20px",
            }}
          >
            <CardContent sx={{ textAlign: "center", pt: 3 }}>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <Select
                  value={selectedPlan}
                  onChange={(e) => {
                    const planId = e.target.value;
                    setSelectedPlan(planId);

                    const selectedScheme = schemes.find(
                      (scheme) => scheme.id === planId
                    );

                    if (selectedScheme) {
                      const parsedBenefits = JSON.parse(
                        selectedScheme.benefits
                      );
                      setBenefits(parsedBenefits);
                    } else {
                      setBenefits([]);
                    }
                  }}
                  disabled
                  displayEmpty
                  sx={{
                    borderRadius: "7px",
                    fontSize: "14px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <MenuItem value="">Select Plan</MenuItem>
                  {schemes.map((scheme) => (
                    <MenuItem key={scheme.id} value={scheme.id}>
                      {scheme.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth sx={{ mb: 3 }}>
                <TextField
                  placeholder="Enter the amount you want"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "20px",
                            fontWeight: 400,
                            color: "#000",
                          }}
                        >
                          ₹
                          <span
                            style={{
                              fontSize: "28px",
                              marginLeft: "10px",
                              marginRight: "10px",
                              color: "#000044",
                              lineHeight: "1",
                            }}
                          >
                            |
                          </span>
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ borderRadius: "10px", backgroundColor: "#fff" }}
                />
              </FormControl>
            </CardContent>

            <CardActions sx={{ justifyContent: "center", mb: 2 }}>
              <ButtonComponent
                buttonText={"Start Now"}
                onClick={selectedPlan === "3" ? handleSavings : handlePayment}
                style={{
                  width: "180px",
                  height: "36px",
                  background: "linear-gradient(to right, #A36E29, #E0B872)",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "14px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 auto",
                }}
              />
            </CardActions>

            <CardContent sx={{ textAlign: "center", pt: 0, pb: 2 }}>
              {/* <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "12px",
                  color: "#444",
                }}
              >
                * Missed an installment or wanna pay your installment?{" "}
                <strong style={{ color: "#A36E29" }}>Pay Now</strong>
              </Typography> */}
            </CardContent>
          </Card>
          <Box
            sx={{
              mt: { xs: 8, sm: 6 },
              px: { xs: 2, sm: 4 },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "90%",
                maxWidth: "400px",
                backgroundColor: "#fff",
                boxShadow: 1,
                borderRadius: "12px",
                p: { xs: 2, sm: 4 },
                mx: "auto",
              }}
            >
              {/* Plan-specific images at the top (mobile) */}
              <Box sx={{ mb: 3, textAlign: "center" }}>
                {selectedPlan === "1" && (
                  <img src={schemeImg1} alt="Scheme 1" style={{ maxWidth: "100%", height: "auto" }} />
                )}
                {selectedPlan === "2" && (
                  <img src={schemeImg2} alt="Scheme 2" style={{ maxWidth: "100%", height: "auto" }} />
                )}
                {selectedPlan === "3" && (
                  <img src={schemeImg3} alt="Scheme 3" style={{ maxWidth: "100%", height: "auto" }} />
                )}
              </Box>

              {/* Heading */}
              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "700",
                  mb: 3,
                  fontSize: { xs: "24px", sm: "28px", md: "32px" },
                  fontFamily: "Open Sans",
                }}
              >
                {currentSchemeDetails.name || "Scheme Details"}
              </Typography>

              {/* Plan Overview */}
              {currentSchemeDetails.overview && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    Plan Overview:
                  </Typography>
                  <Typography sx={{ fontSize: "14px", mb: 3, lineHeight: 1.6 }}>
                    {currentSchemeDetails.overview}
                  </Typography>
                </>
              )}

              {/* Key Features */}
              {currentSchemeDetails.keyFeatures && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    Key Features:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                  >
                    {currentSchemeDetails.keyFeatures.map((feature, index) => (
                      <li key={index}>✅ {feature}</li>
                    ))}
                  </Box>
                </>
              )}

              {/* How It Works (for Daily Savings) */}
              {currentSchemeDetails.howItWorks && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    How It Works:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                  >
                    {currentSchemeDetails.howItWorks.map((step, index) => (
                      <li key={index}>📋 {step}</li>
                    ))}
                  </Box>
                </>
              )}

              {/* Examples */}
              {currentSchemeDetails.examples && currentSchemeDetails.examples.length > 0 && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    Example Calculations:
                  </Typography>
                  {currentSchemeDetails.examples.map((example, index) => (
                    <Box key={index} sx={{ mb: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fafafa" }}>
                      <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "15px", color: "#A36E29" }}>
                        {example.title}
                      </Typography>
                      <Box sx={{ fontSize: "13px", lineHeight: 1.6 }}>
                        {example.details.map((detail, detailIndex) => {
                          if (detail === "TABLE_PLACEHOLDER" && selectedPlan === "3") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderDailyGoldSavingsTable()}
                              </Box>
                            );
                          }
                          if (detail === "TABLE_PLACEHOLDER_PLAN1_GOLD" && selectedPlan === "1") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderPlan1GoldTable()}
                              </Box>
                            );
                          }
                          if (detail === "TABLE_PLACEHOLDER_PLAN1_SILVER" && selectedPlan === "1") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderPlan1SilverTable()}
                              </Box>
                            );
                          }
                          if (detail === "TABLE_PLACEHOLDER_PLAN2_EXAMPLE" && selectedPlan === "2") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderPlan2ExampleTable()}
                              </Box>
                            );
                          }
                          if (detail === "TABLE_PLACEHOLDER_PLAN2_SILVER" && selectedPlan === "2") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderPlan2SilverTable()}
                              </Box>
                            );
                          }
                          if (detail === "TABLE_PLACEHOLDER_2" && selectedPlan === "2") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderCampaignBenefitsTable()}
                              </Box>
                            );
                          }
                          if (detail === "TABLE_PLACEHOLDER_GOLD" && selectedPlan === "2") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderGoldAccumulationTable()}
                              </Box>
                            );
                          }
                          if (detail === "TABLE_PLACEHOLDER_SILVER" && selectedPlan === "2") {
                            return (
                              <Box key={detailIndex} sx={{ mb: 2 }}>
                                {renderSilverAccumulationTable()}
                              </Box>
                            );
                          }
                          return (
                          <Typography key={detailIndex} sx={{ fontSize: "13px", mb: detailIndex < example.details.length - 1 ? 0.5 : 0 }}>
                            {detail}
                          </Typography>
                          );
                        })}
                      </Box>
                    </Box>
                  ))}
                </>
              )}

              {/* Benefits */}
              {currentSchemeDetails.benefits && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    Benefits:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                  >
                    {currentSchemeDetails.benefits.map((benefit, index) => (
                      <li key={index}>🎯 {benefit}</li>
                    ))}
                  </Box>
                </>
              )}

              {/* Benefit Table */}
              {selectedPlan !== "3" && currentSchemeDetails.redemptionDetails && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    Benefit Table:
                  </Typography>
                  {renderBenefitTable(currentSchemeDetails.redemptionDetails)}
                </>
              )}

              {/* Why Choose */}
              {currentSchemeDetails.whyChoose && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    Why Choose This Plan?
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                  >
                    {currentSchemeDetails.whyChoose.map((reason, index) => (
                      <li key={index}>{reason}</li>
                    ))}
                  </Box>
                </>
              )}

              {/* Terms & Conditions */}
              {currentSchemeDetails.termsConditions && (
                <>
                  <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                    Terms & Conditions:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                  >
                    {currentSchemeDetails.termsConditions.map((term, index) => (
                      <li key={index}>📋 {term}</li>
                    ))}
                  </Box>
                </>
              )}


                              {/* Redemption Details */}
                {currentSchemeDetails.redemptionDetails && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Redemption Details:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {currentSchemeDetails.redemptionDetails.map((detail, index) => (
                        <li key={index}>💰 {detail}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* Original API Benefits */}
                {benefits.length > 0 && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Additional Benefits:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {benefits.map((benefit, index) => (
                        <li key={index}>✅ {benefit}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* Original API Benefits */}
                {benefits.length > 0 && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Additional Benefits:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {benefits.map((benefit, index) => (
                        <li key={index}>✅ {benefit}</li>
                      ))}
                    </Box>
                  </>
                )}
            </Box>

          </Box>

          {/* Plan-specific images moved to top - removed from bottom (mobile) */}

          {/* <Box
            sx={{
              position: "relative",
              top: "-100px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: { xs: "60px 16px", sm: "40px 24px" },
              mt: { xs: 8, sm: 0 },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontWeight: 700,
                fontSize: { xs: "22px", sm: "28px", md: "32px" },
                textAlign: "center",
                marginBottom: { xs: "16px", sm: "24px" },
                color: "#333",
              }}
            >
              How does it work?
            </Typography>

            <Box
              component="img"
              src={scheme_steps}
              alt="Scheme Steps"
              sx={{
                width: { xs: "100%", sm: "80%", md: "60%", lg: "371px" },
                maxWidth: "100%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Box> */}
        </div>
      ) : (
        <Box>
          <div
            style={{ width: "100%", overflow: "hidden", marginTop: "100px" }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/${
                planId === "1"
                  ? "24.webp"
                  : planId === "2"
                  ? "23.webp"
                  : "22.webp"
              }`}
              alt="Scheme Background"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              px: { xs: 2, sm: 4 },
              mt: { xs: 6, md: 10 },
              background:
                "linear-gradient(to bottom,rgb(255, 253, 251),rgb(190, 148, 97))",

              //background: "linear-gradient(to bottom, #f4e2d8, #e7c7a8)", // ✅ Move gradient here
              py: { xs: 6, sm: 8 }, // ✅ Add padding for spacing
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap", // Makes it responsive

                gap: { xs: 6, sm: 8, md: 12 },
                mb: { xs: 4, sm: 6 }, // Space below this section
              }}
            >
              {/* Left Ring Logo */}
              <Box
                component="img"
                src={ringLogo}
                alt="Ring Logo Left"
                sx={{
                  width: { xs: "150px", sm: "200px", md: "240px" },
                  height: "auto",
                }}
              />

              {/* Form Card */}
              <Card
                sx={{
                  width: { xs: "90%", sm: "400px" }, // Uniform width
                  borderRadius: "12px",
                  boxShadow: 3,
                  backgroundColor: "#fff",
                  p: 3,
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <Select
                      value={selectedPlan}
                      onChange={(e) => {
                        const planId = e.target.value;
                        setSelectedPlan(planId);

                        const selectedScheme = schemes.find(
                          (scheme) => scheme.id === planId
                        );

                        if (selectedScheme) {
                          const parsedBenefits = JSON.parse(
                            selectedScheme.benefits
                          );
                          setBenefits(parsedBenefits);
                        } else {
                          setBenefits([]);
                        }
                      }}
                      disabled
                      displayEmpty
                      sx={{
                        borderRadius: "8px",
                        backgroundColor: "#f9f9f9",
                        fontSize: "14px",
                      }}
                    >
                      <MenuItem value="">Select Plan</MenuItem>
                      {schemes.map((scheme) => (
                        <MenuItem key={scheme.id} value={scheme.id}>
                          {scheme.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <TextField
                      placeholder="Enter the amount you want"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Box sx={{ fontWeight: 500 }}>₹</Box>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>

                  {isLoading ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <CircularProgress
                        sx={{
                          color: "#A36E29",
                          marginTop: "10px",
                        }}
                      />
                      <Typography>Processing...</Typography>
                    </Box>
                  ) : (
                    <ButtonComponent
                      buttonText={"Start Now"}
                      onClick={
                        selectedPlan === "3" ? handleSavings : handlePayment
                      }
                      style={{
                        width: "100%",
                        height: "50px",
                        background:
                          "linear-gradient(to right, #A36E29, #E0B872)",
                        color: "#fff",
                        fontWeight: "600",
                        fontSize: "14px",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        padding: 0,
                      }}
                    />
                  )}

                  {/* <Typography
                    sx={{
                      mt: 2,
                      fontSize: "12px",
                      color: "#444",
                      fontFamily: "Open Sans",
                      fontWeight: 500,
                    }}
                  >
                    * Missed an installment or want to pay it?{" "}
                    <strong style={{ color: "#A36E29" }}>Pay Now</strong>
                  </Typography> */}
                </CardContent>
              </Card>

              {/* Right Ring Logo */}
              <Box
                component="img"
                src={ringLogo}
                alt="Ring Logo Right"
                sx={{
                  width: { xs: "150px", sm: "200px", md: "240px" },
                  height: "auto",
                }}
              />
            </Box>

            <Box
              sx={{
                mt: { xs: 4, sm: 6 },
                px: { xs: 2, sm: 4 },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "90%",
                  maxWidth: "800px",
                  backgroundColor: "#fff",
                  boxShadow: 1,
                  borderRadius: "12px",
                  p: { xs: 3, sm: 4 },
                }}
              >
                {/* Plan-specific images at the top (desktop) */}
                <Box sx={{ mb: 3, textAlign: "center" }}>
                  {selectedPlan === "1" && (
                    <img src={schemeImg1} alt="Scheme 1" style={{ maxWidth: "100%", height: "auto" }} />
                  )}
                  {selectedPlan === "2" && (
                    <img src={schemeImg2} alt="Scheme 2" style={{ maxWidth: "100%", height: "auto" }} />
                  )}
                  {selectedPlan === "3" && (
                    <img src={schemeImg3} alt="Scheme 3" style={{ maxWidth: "100%", height: "auto" }} />
                  )}
                </Box>

                {/* Heading */}
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    mb: 3,
                    fontSize: { xs: "24px", sm: "28px", md: "32px" },
                    fontFamily: "Open Sans",
                  }}
                >
                  {currentSchemeDetails.name || "Scheme Details"}
                </Typography>

                {/* Plan Overview */}
                {currentSchemeDetails.overview && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Plan Overview:
                    </Typography>
                    <Typography sx={{ fontSize: "14px", mb: 3, lineHeight: 1.6 }}>
                      {currentSchemeDetails.overview}
                    </Typography>
                  </>
                )}

                {/* Key Features */}
                {currentSchemeDetails.keyFeatures && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Key Features:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {currentSchemeDetails.keyFeatures.map((feature, index) => (
                        <li key={index}>✅ {feature}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* How It Works (for Daily Savings) */}
                {currentSchemeDetails.howItWorks && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      How It Works:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {currentSchemeDetails.howItWorks.map((step, index) => (
                        <li key={index}>📋 {step}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* Examples */}
                {currentSchemeDetails.examples && currentSchemeDetails.examples.length > 0 && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Example Calculations:
                    </Typography>
                    {currentSchemeDetails.examples.map((example, index) => (
                      <Box key={index} sx={{ mb: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fafafa" }}>
                        <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "15px", color: "#A36E29" }}>
                          {example.title}
                        </Typography>
                        <Box sx={{ fontSize: "13px", lineHeight: 1.6 }}>
                          {example.details.map((detail, detailIndex) => {
                            if (detail === "TABLE_PLACEHOLDER" && selectedPlan === "3") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderDailyGoldSavingsTable()}
                                </Box>
                              );
                            }
                            if (detail === "TABLE_PLACEHOLDER_PLAN1_GOLD" && selectedPlan === "1") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderPlan1GoldTable()}
                                </Box>
                              );
                            }
                            if (detail === "TABLE_PLACEHOLDER_PLAN1_SILVER" && selectedPlan === "1") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderPlan1SilverTable()}
                                </Box>
                              );
                            }
                            if (detail === "TABLE_PLACEHOLDER_PLAN2_EXAMPLE" && selectedPlan === "2") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderPlan2ExampleTable()}
                                </Box>
                              );
                            }
                            if (detail === "TABLE_PLACEHOLDER_PLAN2_SILVER" && selectedPlan === "2") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderPlan2SilverTable()}
                                </Box>
                              );
                            }
                            if (detail === "TABLE_PLACEHOLDER_2" && selectedPlan === "2") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderCampaignBenefitsTable()}
                                </Box>
                              );
                            }
                            if (detail === "TABLE_PLACEHOLDER_GOLD" && selectedPlan === "2") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderGoldAccumulationTable()}
                                </Box>
                              );
                            }
                            if (detail === "TABLE_PLACEHOLDER_SILVER" && selectedPlan === "2") {
                              return (
                                <Box key={detailIndex} sx={{ mb: 2 }}>
                                  {renderSilverAccumulationTable()}
                                </Box>
                              );
                            }
                            return (
                            <Typography key={detailIndex} sx={{ fontSize: "13px", mb: detailIndex < example.details.length - 1 ? 0.5 : 0 }}>
                              {detail}
                            </Typography>
                            );
                          })}
                        </Box>
                      </Box>
                    ))}
                  </>
                )}

                {/* Benefits */}
                {currentSchemeDetails.benefits && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Benefits:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {currentSchemeDetails.benefits.map((benefit, index) => (
                        <li key={index}>🎯 {benefit}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* Benefit Table */}
                {selectedPlan !== "3" && currentSchemeDetails.redemptionDetails && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Benefit Table:
                    </Typography>
                    {renderBenefitTable(currentSchemeDetails.redemptionDetails)}
                  </>
                )}

                {/* Why Choose */}
                {currentSchemeDetails.whyChoose && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Why Choose This Plan?
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {currentSchemeDetails.whyChoose.map((reason, index) => (
                        <li key={index}>{reason}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* Terms & Conditions */}
                {currentSchemeDetails.termsConditions && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Terms & Conditions:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {currentSchemeDetails.termsConditions.map((term, index) => (
                        <li key={index}>📋 {term}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* Redemption Details */}
                {currentSchemeDetails.redemptionDetails && (
                  <>
                    <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "16px" }}>
                      Redemption Details:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ pl: 2, fontSize: "14px", lineHeight: 1.8, mb: 3 }}
                    >
                      {currentSchemeDetails.redemptionDetails.map((detail, index) => (
                        <li key={index}>💰 {detail}</li>
                      ))}
                    </Box>
                  </>
                )}

                {/* Plan-specific images moved to top - removed from bottom (desktop) */}
              </Box>
            </Box>

            {/* Second Section (How does it work) */}
            {/* <Box
              sx={{
                // mt: { xs: "48px", lg: "170px" },
                mt: { xs: "24px", lg: "80px" },
                textAlign: "center",
                px: { xs: 2, sm: 4 },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  fontSize: { xs: "24px", sm: "28px", lg: "32px" },
                  mb: 3,
                }}
              >
                How does it work?
              </Typography>
              <Box
                sx={{
                  mt: { xs: "48px", lg: "90px" },
                  textAlign: "center",
                  px: { xs: 2, sm: 4 },
                  display: "flex",
                  justifyContent: "center", // ✅ CENTERING
                }}
              >
                <Box
                  component="img"
                  src={scheme_steps}
                  alt="Steps"
                  sx={{
                    width: { xs: "100%", sm: "90%", md: "80%", lg: "1018px" },
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              </Box>
            </Box> */}
          </Box>
        </Box>
      )}
    </>
  );
};

export default Schemes_form;
